function createSet() {
    return {};
}
function addToSet(l, s) {
    l[s] = '';
}
function removeFromSet(l, s) {
    delete l[s];
}
function toSet(elements) {
    const literal = {};
    if (elements !== undefined) {
        for (const e of elements) {
            literal[e] = '';
        }
    }
    return literal;
}
function fromSet(l) {
    if (l !== undefined) {
        for (const v of Object.values(l)) {
            if (v !== '') {
                throw new Error('Malformed LiteralSet: ' + l.toString() + ' (all values should be empty strings, found "' + v + '" instead).');
            }
        }
    }
    return Object.keys(l || {});
}
function getSet(l) {
    return new Set(fromSet(l));
}
function copySet(l) {
    return Object.assign({}, l);
}
function setUnion(l1, l2) {
    return Object.assign(Object.assign({}, l1), l2);
}
function setElements(l) {
    return Object.keys(l);
}
function setSize(l) {
    return Object.keys(l).length;
}
function isEmptySet(l) {
    return Object.keys(l).length === 0;
}
export { createSet, addToSet, removeFromSet, copySet, toSet, fromSet, getSet, setUnion, setElements, setSize, isEmptySet };
